<template>
  <div class="loan protocol">
    <navigation sticky>借款协议</navigation>

    <section class="content">
      <p class="text tab-2">
        贷款人（甲方）：重庆市崇天小额贷款有限公司
      </p>
      <p class="text tab-2 margin-top-20">
        营业执照号码：91500000051700103N
      </p>
      <p class="text tab-2 margin-top-20">
        住所地：重庆市南岸区南滨路22号1栋长江国际大厦33层3319室
      </p>
      <p class="text tab-2 margin-top-20">
        联系电话：4000100008
      </p>
      <p class="text tab-2 margin-top-20">
        邮政编码：400000
      </p>
      <p class="text tab-2 margin-top-40">
        借款人（乙方）:<underline :width="3"></underline>
      </p>
      <p class="text tab-2 margin-top-20">
        身份证号码：<underline :width="3.4"></underline>
      </p>
      <p class="text tab-2 margin-top-20">
        住所地：<underline :width="4"></underline>
      </p>
      <p class="text tab-2 margin-top-20">
        联系电话：<underline :width="3.7"></underline>
      </p>
      <p class="text tab-2 margin-top-20">
        邮政编码：<underline :width="3.7"></underline>
      </p>
      <p class="text margin-top-40">
        根据《中华人民共和国合同法》及相关法律法规、司法解释等，经甲乙双方平等协商一致签订本合同，以明确各方权利和义务。
      </p>
      <p class="title">
        第一条 借款用途
      </p>
      <p class="text">
        乙方向甲方借款，用于<underline :width="3"></underline>。未经甲方书面同意，乙方不得改变借款用途。
      </p>
      <p class="title">
        第二条 借款金额与期限
      </p>
      <p class="text">
        借款金额为¥<underline :width="2"></underline>元（大写：人民币<underline :width="3"></underline>）。
      </p>
      <p class="text">
        借款期限<underline :width="1"></underline>期，自<underline :width="1"></underline>年<underline :width="1"></underline>月<underline :width="1"></underline>日起至<underline :width="1"></underline>年<underline :width="1"></underline>月<underline :width="1"></underline>日。
      </p>
      <p class="text">
        实际借款期限、借款金额、发放日期以划款凭证记载为准。划款凭证为本合同组成部分，与本合同具有同等法律效力。
      </p>
      <p class="title">
        第三条 贷款利率
      </p>
      <p class="text">
        甲方发放给乙方的贷款，固定年利率<underline :width="0.4"></underline>%，在约定的借款期限内，需要调整借款利率或计息方式的，必须由甲、乙双方协商确定。
      </p>
      <p class="title">
        第四条 贷款发放
      </p>
      <p class="title">
        一、满足下列条件时，甲方始向乙方发放贷款：
      </p>
      <p class="text">
        （一）本合同已经有权各方签署，且乙方根据甲方要求签署所有必要文书，提供必要证照、证明、单据等文件、资料，并完成相关手续，且前述文件、资料及相关手续持续合法有效；
      </p>
      <p class="text">
        （二）本合同项下的担保合同（如有）已生效并持续合法有效，如担保合同系质押合同及/或抵押合同的，担保物权已设立并持续合法有效；
      </p>
      <p class="text">
        （三）乙方未出现任何影响或可能影响乙方偿付能力的重大不利情形；
      </p>
      <p class="text">
        （四）担保人或担保物未出现任何影响担保能力的重大不利情形；
      </p>
      <p class="text">
        （五）乙方未出现任何违反本合同约定的情形。
      </p>
      <p class="text">
        （六）其他：<underline :width="3.5"></underline>
      </p>
      <p class="title">
        二、甲方将贷款划入乙方指定的以下账户：
      </p>
      <p class="text">
        户 名：<underline :width="4"></underline>
      </p>
      <p class="text">
        账 号：<underline :width="4"></underline>
      </p>
      <p class="text">
        开户银行：<underline :width="3.5"></underline>
      </p>
      <p class="text">
        若上列账户非借款人本人账户或合同签订后发生变更，乙方应出具受托支付说明书。
      </p>
      <p class="text">
        三、甲方在发放贷款前，发现乙方提供虚假信息与资料、签章不真实，或者有其他足以危及贷款安全的重大情形的，有权停止发放贷款。
      </p>
      <p class="title">
        第五条 还款与利息支付方式
      </p>
      <p class="text">
        一、结息时间与方式与采用以下第（一）种：
      </p>
      <p class="text">
        （一）按月结息，结息日为每月固定日；
      </p>
      <p class="text">
        （二）按月结息，贷款发放日对应的每月相同时间；
      </p>
      <p class="text">
        （三）按季结息，结息日为每季末月的<underline :width="0.5"></underline>日；
      </p>
      <p class="text">
        （四）利随本清，利息于借款全部到期日一次付清。
      </p>
      <p class="text">
        结息日为法定节假日或公休日，应在法定节假日或公休日前最后一个银行营业日归还贷款的，按合同利率计收利息，但应扣除到期日与归还日之间的天数所对应的按合同利率计算的利息；在法定节假日或公休日后第一个银行营业日归还贷款的，按合同利率加收到期日与归还日之间的天数所对应的利息，在法定节假日或公休日后第一个银行营业日未归还贷款的，从该日期起按逾期贷款计收利息。
      </p>
      <p class="text">
        二、还本付息采用下列第（七）种方式：
      </p>
      <p class="text">
        （一）按月付息到期还本：按月付息到期一次性还本；
      </p>
      <p class="text">
        （二）按季付息到期还本：按季付息到期一次性还本；
      </p>
      <p class="text">
        （三）到期一次性还本付息：在贷款到期日一次性还本付息；
      </p>
      <p class="text">
        （四）等额本息：每次偿还的本息金额相同，其中每次偿还的本金逐次增加、利息逐次减少；
      </p>
      <p class="text">
        （五）等额本金：每次偿还的本息金额逐次减少，其中每次偿还的本金相同、利息逐次减少。
      </p>
      <p class="text">
        （六）预收利息分期还本付息：在贷款发放时从本金中扣除部分利息，扣除部分不再作为本金重复计息
      </p>
      <p class="text">
        （七）分期还款：双方协商约定不同期次的还本金额，利息逐次减少，具体约定以还款计划书为准。
      </p>
      <p class="text">
        三、乙方支付利息或者归还本金时，应存入甲方指定以下账户：
      </p>

      <p class="text">
        户 名：重庆市崇天小额贷款有限公司
      </p>
      <p class="text">
        账号：2008952679000197
      </p>
      <p class="text">
        开户银行：渤海银行重庆分行营业部
      </p>

      <p class="text">
        四、甲方可以通过委托银行代扣代收本息的方式收款，但双方需另行与受托银行签订相关协议，在此情况下，乙方应在本合同约定的结息日或者贷款到期日前将用于支付利息以及归还本金的资金足额存入协议约定账户。
      </p>
      <p class="text">
        五、本合同项下借款利息自甲方将借款划款之日起开始计算，若为甲方分期支付，则（从第一笔借款支付之日起算）按笔以如下公式进行计算。
        利息计算公式为：利息=本金×实际占用本金天数×日利率，日利率=年利率/360
      </p>
      <p class="title">
        六、除双方另有约定外，乙方未按时足额还本付息的，已经偿还的全部金额优先抵偿已经产生的利息及费用，余额用于偿还本金，不足以清偿全部本金的，甲方有权决定乙方所付款项偿还借款的顺序；对有  2  笔（含）以上借款到期的情况下，甲方有权决定乙方所付款项偿还借款的顺序。
      </p>
      <p class="text">
        七、本债权同时存在物的担保（含债务人或第三人提供）和保证担保的，债权人可以就物的担保实现债权，也可以要求保证人承担保证责任。债权人已经选择某一担保来实现债权的，也可同时主张通过其他担保来实现全部或部分债权。            </p>
      <p class="title">
        第六条 提前还款
      </p>
      <p class="text">
        一、经甲方书面同意后，乙方可提前还款。乙方因情况变化需全部或者部分提前还款时，应提前一周<span class="underline">书面通知</span>甲方，告知提前还款金额与时间。
      </p>
      <p class="text">
        二、如果借款分期到期的，提前还款的金额按照到期<span class="underline">先后顺序依次</span>进行还款。
      </p>
      <p class="text">
        三、乙方提前归还借款的，应支付当期应还利息及所有剩余本金。
      </p>
      <p class="title">
        第七条 罚息
      </p>
      <p class="text">
        一、对逾期或未按合同约定用途使用借款的，从逾期或挪用之日起，就逾期或挪用部分，按本款约定的罚息利率计收罚息，直至清偿本息为止。对既逾期又挪用的贷款，按照较高的罚息利率计收罚息。
      </p>
      <p class="text">
        二、对借款人不能按期支付的利息以及罚息，以第六条约定的结息方式，按本款约定的罚息利率计收复利。
      </p>
      <p class="text">
        三、罚息利率：逾期贷款罚息按正常利率计算。
      </p>
      <p class="title">
        第八条 担保措施
      </p>
      <p class="text">
        对本合同项下借款，乙方提供以下担保措施：
      </p>
      <p class="text">
        一、由<underline :width="3"></underline>提供连带责任保证担保；
      </p>
      <p class="text">
        二、以<underline :width="3"></underline>设置抵押担保；
      </p>
      <p class="text">
        三、以<underline :width="3"></underline>设置质押担保。
      </p>
      <p class="text">
        本条约定的担保措施，双方或者甲方与担保方另行签订担保合同，依据法律规定担保物权需经登记生效的，应依法登记。
      </p>
      <p class="title">
        第九条 贷款使用监督
      </p>
      <p class="text">
        为监督乙方借款用于约定用途和确保乙方按约定期限偿还借款本息，甲方对乙方使用贷款期间的经营管理活动、重大事项决策、重大财产处分行为有权进行监督，乙方应按甲方要求提供相关的财务报表、凭证及合同等资料予以配合。具体监督办法双方可另行签订协议约定。
      </p>
      <p class="title">
        第十条 贷款展期
      </p>
      <p class="text">
        乙方申请展期的，应按约定还款期限提前 7 日向甲方书面提出。甲方经审查同意展期的，双方另行签订书面协议确认；甲方不同意展期的，乙方仍按本合同约定期限履行还款义务或者承担违约责任。
      </p>
      <p class="title">
        第十一条 提前到期
      </p>
      <p class="text">
        有下列情况之一的，甲方均可随时以通知的方式解除本合同关于借款期限的约定，要求乙方立即偿还借款本息：
      </p>
      <p class="text">
        一、未按期偿还本金或未按期支付利息。
      </p>
      <p class="text">
        二、未按约定的借款用途使用借款的。
      </p>
      <p class="text">
        三、未按期向甲方清偿其他到期债务或未按期清偿其他任何金融机构或第三人到期债务的。
      </p>
      <p class="text">
        四、乙方为签订本合同向甲方提供的信息与资料有任何一项虚假的；未提供真实、完整的财务报表或其他相关资料、信息；不积极配合甲方对其生产经营、财务活动及本合同项下借款使用情况的检查的。
      </p>
      <p class="text">
        五、进行或申请进行破产、申请停业整顿、解散、歇业，或被上级主管部门撤销或停业。
      </p>
      <p class="text">
        六、涉及诉讼、仲裁或其资产被扣押、查封、冻结、强制执行或被采取了具有同样效力的其他措施。
      </p>
      <p class="text">
        七、签署对履行本合同项下义务的能力有重大不利影响的合同、协议或承担具有这一影响的有关义务。
      </p>
      <p class="text">
        八、未征得债权人书面同意而转让(包括出售、赠与、抵债、交换等形式)、抵押、质押或以其他方式处分其重大资产的全部或大部分以及为他人债务提供保证。
      </p>
      <p class="title">
        第十二条 声明与承诺
      </p>
      <p class="title">
        一、乙方声明：
      </p>
      <p class="text">
        乙方作出如下声明和保证，且该声明和保证应视同在甲方每次按照本合同的约定向乙方提供融资时，由乙方重复做出：
      </p>
      <p class="text">
        （一）乙方为自然人，具备签订和履行本合同所需的完全民事权利能力和行为能力；签署和履行本合同系基于乙方的真实意思表示，已对其具有法律约束力。
      </p>
      <p class="text">
        <span class="font-weight-bolder">
          （二）乙方同意甲方根据有关监管规定，将与本合同有关的信息和乙方其他相关信息提报送小额贷款公司的监管部门、行业自律组织和监管信息系统，供监管部门使用和乙方授权查询使用。
        </span>
      </p>
      <p class="text">
        <span class="font-weight-bolder">
          （三）乙方同意甲方根据有关法律法规、监管规定，将与本合同有关的信息和乙方其他相关信息提供给中国人民银行征信系统和其他依法设立的信用信息数据库。甲方有权为本合同订立和履行之目的，通过中国人民银行征信系统和其他依法设立的信用信息数据库查询乙方和保证人的相关信息
        </span>
      </p>
      <p class="text">
        <span class="font-weight-bolder">
          （四）乙方在此保证，将按照本合同约定的借款用途使用借款，并按本合同约定的还款、付息时间按期归还借款本息；如违反本合同约定时，甲方除依法追究乙方违约责任外，有权将乙方的违约行为录入行业监管系统和征信系统。
        </span>
      </p>
      <p class="text">
        （五）乙方在此保证，在签署和履行本合同过程中恪守诚实守信原则，其所出具的涉及乙方以及涉及本合同的所有文件、信息和资料均为真实、有效、完整、准确而无任何隐瞒的。
      </p>
      <p class="text">
        （六）乙方在此保证，其签署和履行本合同的行为并不违反其所应遵守的法律、法规、规章、判决、裁决及命令，也不与其签署的任何合同、协议或承担的任何其他义务相抵触。
      </p>
      <p class="text">
        （七）乙方在此保证，将严格遵守法律、法规的规定，严格按照乙方的营业执照规定的或依法核定的经营范围开展各项业务，按时办理注册年检手续。
      </p>
      <p class="text">
        （八）乙方在此保证，在本合同签署时没有隐瞒已经发生或将要发生的任何影响或可能影响其签署或履行本合同、或可能对其财务状况产生不利影响的诉讼案件、仲裁案件、行政程序、财产保全措施、强制执行程序或其他不利影响的事件；并且，乙方将在本合同履行期内继续向甲方承担上述信息的及时披露义务。在发生前述事件时，乙方在发生之日或其知悉之日通知甲方。
      </p>
      <p class="text">
        （九）乙方在此保证，其住址、或联系地址、联系电话等信息发生变更后，自该变更发生之日书面通知甲方。
      </p>
      <p class="text">
        （十）乙方保证其为签署、履行本合同所需的所有手续均已合法办理完毕并有效。
      </p>
      <p class="text">
        （十一）乙方保证在贷款期间，因担保物价值发生减少，将根据甲方的要求，提供、增加或变更担保措施。
      </p>
      <p class="text">
        （十二）乙方保证不存在对其履约能力造成或可能造成不利影响的其他情况或事件。
      </p>
      <p class="title">
        二、乙方承诺：
      </p>
      <p class="text">
        （一）乙方按时偿还借款本息并支付相关费用，并承诺严格遵守并履行本合同项下的各项义务。
      </p>
      <p class="text">
        （二）乙方在贷款发放后因使用该贷款资金与他人发生的任何纠纷，均与甲方无关，本借款合同正常履行。
      </p>
      <p class="text">
        （三）乙方当在获悉其卷入或可能卷入任何可能对其产生不利影响的经济、民事、刑事、行政诉讼程序或类似仲裁程序之日，或在获悉其任何重要资产涉及任何强制执行、查封、扣押、冻结、留置、监管或其他具有同等效力的措施之日，立即通知甲方并详细说明所构成的影响及已采取或计划采取的补救措施，并于获悉该事件发生之日起三个工作日内将书面通知、证明和说明文件原件（法人和其他组织须加盖公章，自然人须经签署）送达甲方。
      </p>
      <p class="text">
        （四）乙方承诺不违反本合同约定的正常偿还次序而对其他贷款予以优先清偿，且现在和将来不签署任何致使本合同项下的贷款处于从属地位的合同。
      </p>
      <p class="text">
        （五）自本合同签署之日起，至本合同项下的债务全部清偿完毕之前，未经甲方书面同意，乙方不得：
      </p>
      <p class="text">
        （1）如乙方经营企业的，其经营企业进行清算、重整、破产、合并（被兼并）、分立、重组、解散、减资或类似法律程序；
      </p>
      <p class="text">
        （2）出售、出租、赠与、转移或以其它任何方式处分其任何重要资产；
      </p>
      <p class="text">
        （3）如乙方经营企业的，其经营企业股权结构发生任何变更；
      </p>
      <p class="text">
        （4）为第三方提供足以对其财务状况或其履行本合同项下的义务的能力产生不利影响的担保；
      </p>
      <p class="text">
        （5）签署对乙方履行本合同项下义务的能力有不利影响的合同/协议或承担具有这一影响的有关义务；
      </p>
      <p class="text">
        （六）本合同项下的担保在遇到特定情形或发生特定变化时，乙方会按照甲方的要求及时提供甲方认可的其他担保。该特定情形或特定变化包括但不限于担保人停产、歇业、解散、停业整顿、营业执照被吊销或被撤销、申请或被申请重整、破产、经营或财务状况有重大变化、涉及诉讼或仲裁案件、法定代表人、董事、监事、主要经营管理人员涉案、担保物的价值减少或可能减少或被采取查封等财产保全措施、在担保合同项下有违约行为以及要求解除担保合同等。
      </p>
      <p class="text">
        （七）乙方随时通知甲方任何可能影响其履行本合同及与本合同相关的任何文件项下义务的能力的事件。
      </p>
      <p class="title">
        第十三条 甲方违约责任
      </p>
      <p class="text">
        一、满足本合同约定贷款发放条件，甲方无正当理由延期或者拒不发放贷款的，应赔偿乙方因此而发生的经济损失。
      </p>
      <p class="text">
        二、要求贷款人赔偿因其违约而给借款人造成的损失，包括但不限于因实现债权而导致的诉讼费、律师费、公证费、执行费等相关费用损失。
      </p>
      <p class="title">
        第十四条 乙方违约责任
      </p>
      <p class="text">
        乙方因违反本合同约定，造成借款不能及时足额偿还，甲方有权采取下列一种或数种措施进行处理：
      </p>
      <p class="text">
        一、要求借款人、担保人限期纠正其违约行为；
      </p>
      <p class="text">
        二、单方面调整乙方的还款方式；
      </p>
      <p class="text">
        三、单方面调整乙方的贷款支付方式；
      </p>
      <p class="text">
        四、宣布本合同项下的乙方已提用贷款部分的本息立即部分或全部提前到期，未提用部分取消，并通过各种形式向乙方及担保人追索；
      </p>
      <p class="text">
        五、要求借款人赔偿因其违约而给贷款人造成的损失，包括但不限于因实现债权而导致的诉讼费、律师费、公证费、执行费等相关费用损失；
      </p>
      <p class="text">
        六、要求乙方另行提供经甲方认可的保证、抵押、质押或其他担保；
      </p>
      <p class="text">
        七、按乙方为本贷款所提供担保的担保合同约定处分抵押物或质物，清偿贷款本息，或依法追索保证人的连带责任；
      </p>
      <p class="text">
        八、采取法律法规允许的其他必要措施；
      </p>
      <p class="text">
        九、其他处理方式<underline :width="3"></underline>
      </p>
      <p class="title">
        第十五条 争议解决
      </p>
      <p class="text">
        一、本合同适用中华人民共和国法律（基于本合同之目的，在此不包括香港、澳门特别行政区和台湾地区法律），并按其解释。有关本合同的一切争议可通过友好协商解决；协商不成的，双方当事人选择<span class="underline">向甲方住所地人民法院提起诉讼</span>解决，争议期间，各方仍应继续履行未涉争议的条款：
      </p>
      <p class="text">
        二、在争议解决期间，若该争议不影响本合同其他条款的履行，则其他条款应继续履行。
      </p>
      <p class="title">
        第十六条 通知与送达
      </p>
      <p class="text">
        一、本合同书项下任何通知或函件或法律文书（包括但不限于诉讼和仲裁文书）的送达均应以书面形式邮寄至本合同开头载明的联系地址。如任何一方的联系地址、联系电话发生变更时，应在变更后的三日内以书面形式通知对方，否则另一方或法院或仲裁机构按本合同开头载明的联系地址  邮寄通知、函件、或法律文书，即视为送达，变动方应自行承担相应的法律责任；
      </p>
      <p class="text">
        二、乙方若认为邮件封面标题与邮件中实际文件内容不符的，应在自收到邮件之日起三个工作日内书面通知甲方，逾期视为邮件封面标题与邮件中实际文件内容一致。
      </p>
      <p class="title">
        第十七条 赋予强制执行效力公证
      </p>
      <p class="text">
        一、为确保按时偿还借款本息，乙方同意就本合同向公证处申请赋予强制执行效力公证并接受人民法院执行强制公证；乙方未履行或未完全履行本合同规定义务，乙方自愿放弃诉讼并接受法院执行；
      </p>
      <p class="text">
        二、经双方协商约定，本合同公证费用由乙方承担；
      </p>
      <p class="text">
        三、如果双方未就本合同申请赋予强制执行效力公证，本条约定不适用。
      </p>
      <p class="title">
        第十八条 权利保留
      </p>
      <p class="text">
        一、一方若未行使本合同项下部分或全部权利，或未要求另一方履行、承担部分或全部义务、责任，并不构成该方对该权利的放弃或对该义务、责任的豁免。
      </p>
      <p class="text">
        二、一方对另一方的任何宽容、展期或者延缓行使本合同项下的权利，均不影响其根据本合同及法律、法规而享有的任何权利，亦不视为其对该权利的放弃。
      </p>
      <p class="title">
        第十九条 其他条款
        <underline :width="6"></underline>
      </p>
      <p class="title">
        第二十条 文本及生效
      </p>
      <p class="text">
        本合同涉及的其他合同与协议均为本合同附件，为本合同的组成部分，与本合同具有同等法律效力。
      </p>
      <p class="text">
        本合同一式三份，双方各持一份，一份用于公证或者抵押、质押登记，具有同等法律效力。
      </p>
      <p class="text">
        本合同经借贷双方或其授权签字人签署之日起生效。
      </p>
      <p class="underline text">
        甲方工作人员已提醒乙方注意对本合同各条款作全面、准确的理解，并应乙方的要求作了相应的条款说明，现乙方已清楚知悉应承担的所有合同义务和责任。签约各方对本合同条款的含义认识一致。
      </p>
      <p class="text tab-0 margin-top-40">
        贷款人（甲方）：重庆市崇天小额贷款公司
      </p>
      <p class="text tab-0 margin-top-20">
        <underline :width="1"></underline>年<underline :width="1"></underline>月<underline :width="1"></underline>日
      </p>
      <p class="text tab-0 margin-top-40">
        借款人（乙方）：<underline :width="3.2"></underline>
      </p>
      <p class="text tab-0 margin-top-20">
        <underline :width="1"></underline>年<underline :width="1"></underline>月<underline :width="1"></underline>日
      </p>
    </section>
  </div>
</template>

<script>
import underline from './underline'

export default {
  name: 'loan-protocoltmd',

  components: {
    underline
  }
}
</script>ss
